import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import Alphabet from "@src/modules/MorseCode/helpers/alphabet";
import { Signal } from "@src/modules/MorseCode/helpers/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'MorseCodeDocumentation',
  setup(__props) {

const table1: Array<{ letter: string; signal: Array<Signal> }> = computed(
  () => {
    const keys = Object.keys(Alphabet);
    const size = Math.ceil(keys.length / 3);
    const result = [];

    for (let i = 0; i < size; i++) {
      result.push({
        letter: keys[i],
        signal: Alphabet[keys[i]],
      });
    }

    return result;
  },
);

const table2: Array<{ letter: string; signal: Array<Signal> }> = computed(
  () => {
    const keys = Object.keys(Alphabet);
    const size = Math.ceil(keys.length / 3);
    const result = [];

    for (let i = size; i < size * 2; i++) {
      result.push({
        letter: keys[i],
        signal: Alphabet[keys[i]],
      });
    }

    return result;
  },
);

const table3: Array<{ letter: string; signal: Array<Signal> }> = computed(
  () => {
    const keys = Object.keys(Alphabet);
    const size = Math.ceil(keys.length / 3);
    const result = [];

    for (let i = size * 2; i < keys.length; i++) {
      result.push({
        letter: keys[i],
        signal: Alphabet[keys[i]],
      });
    }

    return result;
  },
);

function createSignalString(signal: Array<Signal>): string {
  let result = "";

  for (const part of signal) {
    result += part === Signal.DIT ? " •" : " —";
  }

  return result;
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card_title, { class: "text-h4 mt-6" }, {
      default: _withCtx(() => [
        _createTextVNode("Morse-code")
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_v_card_text, { class: "text-body-1 mt-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_table, { density: "compact" }, {
                  default: _withCtx(() => [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table1.value, (row) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(row.letter), 1 /* TEXT */),
                          _createElementVNode("td", {
                            innerHTML: createSignalString(row.signal)
                          }, null, 8 /* PROPS */, _hoisted_1)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_table, { density: "compact" }, {
                  default: _withCtx(() => [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table2.value, (row) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(row.letter), 1 /* TEXT */),
                          _createElementVNode("td", {
                            innerHTML: createSignalString(row.signal)
                          }, null, 8 /* PROPS */, _hoisted_2)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_table, { density: "compact" }, {
                  default: _withCtx(() => [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table3.value, (row) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(row.letter), 1 /* TEXT */),
                          _createElementVNode("td", {
                            innerHTML: createSignalString(row.signal)
                          }, null, 8 /* PROPS */, _hoisted_3)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})